import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import customerIcon from "../Assets/icons/CustomerSatisfaction.gif";
import startIcon from "../Assets/icons/Excellence.gif";
import ideaIcon from "../Assets/icons/Innovation.gif";
import { isMobile } from "../App";

const CoreValues = ({ setInitialIndex, initialIndex }) => {
  const [centerIndex, setCenterIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const sliderRef = useRef(null);

  const values = [
    {
      img: customerIcon,
      text: (
        <>
          Customer
          <br />
          Satisfaction
        </>
      ),
      description:
        "Your satisfaction is our driving force. We listen closely to your needs, and collaborate on every step of the process.",
    },
    {
      img: startIcon,
      text: "Excellence",
      description:
        "We are deeply committed to integrity, reliability, and valuing sustainability. Our focus on delivering the highest quality in every product we manufacture ensures lasting value for our clients.",
    },
    {
      img: ideaIcon,
      text: "Innovation",
      description:
        "We love engineering and thrive on the toughest, most challenging projects. By tackling these difficult problems, we push boundaries, deliver innovative solutions, and set new benchmarks.",
    },
  ];

  const settings = {
    useCSS: true,
    vertical: true,
    centerMode: true,
    slidesToShow: 3,
    focusOnSelect: true,
    speed: 500,
    centerPadding: isMobile ? "175px" : "190px",
    autoplay: !isPaused,
    autoplaySpeed: 1250,
    infinite: true,
    beforeChange: (_, next) => setCenterIndex(next),
  };

  // useEffect(() => {
  //   if (initialIndex) {
  //     sliderRef.current?.slickGoTo(0);
  //   }
  // }, [initialIndex]);

  // Ensure autoplay toggles properly
  useEffect(() => {
    if (isPaused) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
  }, [isPaused]);

  const handlePause = (index) => {
    if (index === centerIndex && !isPaused) {
      setIsPaused(true);
    }
  };

  const handleResume = (index) => {
    if (index === centerIndex && isPaused) {
      setTimeout(() => {
        setIsPaused(false);
      }, 100); // Small delay for smoother UX
    }
  };

  return (
    <div className="about-info-container" id="core-values">
      <p className="title-text-about mb-5" id="core-values-section">
        Core Values
      </p>
      <div className="center-slider">
        <Slider ref={sliderRef} {...settings}>
          {values.map((value, index) => {
            const isCenter = index === centerIndex;
            const showDescription = isCenter && isPaused;

            return (
              <div
                key={index}
                className={`core_value_icon_cover ${showDescription ? "activecard" : "inactivecard"}`}
                onMouseEnter={() => handlePause(index)}
                onMouseLeave={() => handleResume(index)}
                onTouchStart={() => handlePause(index)}
                onTouchEnd={() => handleResume(index)}
              >
                <div className={`content-wrapper ${showDescription ? "hidden-content" : ""}`}>
                  <img src={value.img} alt={value.text} />
                  <p>{value.text}</p>
                </div>
                <div className={`content-wrapper ${showDescription ? "" : "hidden-content"}`}>
                  <p className="mt-4 fontdecriptin">{value.description}</p>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
      <p className="mt-3 text-center description-text">
        These core values are the <b>DNA</b> of our company. They guide our
        actions, shape our decisions, and drive us to deliver exceptional
        results, creating a brighter future together.
      </p>
    </div>
  );
};

export default CoreValues;
